import { render, staticRenderFns } from "./CarouselBlock.vue?vue&type=template&id=5332ec09&"
import script from "./CarouselBlock.vue?vue&type=script&lang=js&"
export * from "./CarouselBlock.vue?vue&type=script&lang=js&"
import style0 from "./carousel-block.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports